import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled from './HospitalOpinion.module.css'
import axios from 'axios'
import { BASEURL } from '../../config'
import useAccountStore from '../../stores/account'
import useOpinionStore from '../../stores/opinion'

const HospitalOpinion = () => {
    const {accessToken} = useAccountStore()
    const {opinionList, setOpinionList, curOpinion, setCurOpinion} = useOpinionStore()
    const [menu, setMenu] = useState<number>(0)

    // default Opinions data load from server
    const loadOpinionList = async() => {    
        const data = await axios.get(`${BASEURL}/opinion/list`, {
            headers: {Authorization: `Bearer ${accessToken}`,}
        }).then(res=>res.data).then(data => {
            if (data.status === "success") {
                setOpinionList(data.data)
            } else { return null }
        }).catch(error => {
            alert(`소견서 불러오기 실패`)
            return null
        })
    }

    useEffect(()=>{ loadOpinionList() },[])

    const handleMenu = (number:number) => {
        setMenu(number)
        setCurOpinion(null)
    }
    // 소견서의 내용을 보여주는 컴포넌트
    const SogyunseoDetails = () => {
        const formatDateToYYYYMMDD = (date:any) => {
            if (!date) return ""
          
            const d = new Date(date)
            const year = d.getFullYear()
            const month = (`0${d.getMonth() + 1}`).slice(-2) // 월은 0부터 시작하므로 1을 더해줍니다.
            const day = (`0${d.getDate()}`).slice(-2)
          
            return `${year}.${month}.${day}`
        }

        return (
            <div className={styled.details}>
                <div className={styled.info}>
                    <div>
                        <div className={styled.title}>
                            {`${curOpinion?.petName} 소견서`}
                        </div>
                        <div className={styled.date}>{formatDateToYYYYMMDD(curOpinion?.createdAt)}</div>
                    </div>
                    
                    <div id={styled.name}>
                        <div className={styled.tit}> 수신자 </div>
                        <p>{curOpinion?.writer}</p>
                    </div>
                    <div id={styled.name}>
                        {curOpinion?.receiver && (<>
                            <div className={styled.tit}> 발신자 </div>
                            <p>{curOpinion?.receiver}</p>
                        </>)}
                    </div>
                </div>
                <div className={styled.section}>
                    <div className={styled.column}>
                        <div className={styled.tit}>환자이름</div>
                        <div className={styled.obj}>{curOpinion?.petName}</div>
                    </div>
                    <div className={styled.column}>
                        <div className={styled.tit}>보호자 성함</div>
                        <div className={styled.obj}>{curOpinion?.guardianName}</div>
                    </div>
                    <div className={styled.column}>
                        <div className={styled.tit}>종 / 나이</div>
                        <div className={styled.obj}>{curOpinion?.petKind} / {`${curOpinion?.petAge}M`}</div>
                    </div>
                    <div className={styled.column}>
                        <div className={styled.tit}>성별</div>
                        <div className={styled.obj}>{curOpinion?.petGender}</div>
                    </div>
                    <div className={styled.column}>
                        <div className={styled.tit}>진단명</div>
                        <div className={`${styled.obj} ${styled.boldText}`}>                  
                        {curOpinion?.diagnosis?.split('\n').map((item, index) => (
                            <span key={index}>
                                {item}
                                <br />
                            </span>
                        )) || null}
                        </div>
                    </div>
                    <div className={styled.column}>
                        <div className={styled.tit}>주치의 소견</div>
                        <div className={styled.obj}>
                            {curOpinion?.doctorOpinion?.split('\n').map((item, index) => (
                            <span key={index}>
                            {item}
                            <br />
                            </span>
                        )) || null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    
    const SogyunseoList = ({sogyunseoList, checkList, setCheckList }: { 
        sogyunseoList: any[],
        checkList: number[],
        setCheckList: React.Dispatch<React.SetStateAction<number[]>>}) => {
        // 체크 상태를 업데이트하는 함수
        const setCheck = (id: number, isChecked: boolean) => {
            setCheckList((prevList:any) => isChecked ? [...prevList, id] : prevList.filter((item:any) => item !== id))
        }

        // 전체 선택/해제 처리
        const toggleSelectAll = (isChecked: boolean) => {
            if (isChecked) {
                // 전체 선택
                const allIds = sogyunseoList.map((item: any) => item.id)
                setCheckList(allIds)
            } else {
                // 전체 해제
                setCheckList([])
            }
        }

        // menu 0: 전체 문서, 1: 소견서, 2: 보험진단서, 3: 휴지통
        // menu에 따라서 불러온 문서를 필터링해서 보여줌
        
        return (
            <div className={styled.list}>
                <div className={`${styled.item} ${styled.first}`}>
                    <div className={styled.check}>
                        <input type="checkbox" 
                        onChange={(e) => toggleSelectAll(e.target.checked)}
                        checked={checkList.length === sogyunseoList?.length}/> 
                    </div>
                    <div className={styled.title}>진단명</div>
                    <div className={styled.recipient}>작성자</div>
                    <div className={styled.guardian_name}>보호자이름</div>
                    <div className={styled.patient_name}>환자이름</div>
                    <div className={styled.sent_time}>작성시간</div>
                </div>
                {sogyunseoList?.map((sogyunseo:any, index:number) => {
                    const isChecked = checkList.includes(sogyunseo.id)
                    return <SogyunseoItem 
                                key={index}
                                isChecked={isChecked}
                                setCheck={setCheck}
                                sogyunseo={sogyunseo}/>})}
            </div>
        )
    }

    const SogyunseoItem = ({ sogyunseo, isChecked, setCheck } : {
        sogyunseo: any
        isChecked: boolean
        setCheck: (id: number, isChecked: boolean) => void
    }) => {
        const formatDateToDateTimeString = (date:any) => {
            if (!date) return "-"
          
            const d = new Date(date)
            const year = d.getFullYear()
            const month = (`0${d.getMonth() + 1}`).slice(-2) // 월은 0부터 시작하므로 1을 더해줍니다.
            const day = (`0${d.getDate()}`).slice(-2)
            const hours = (`0${d.getHours()}`).slice(-2)
            const minutes = (`0${d.getMinutes()}`).slice(-2)
            return `${year}.${month}.${day} ${hours}:${minutes}`
        }

        return (
            <div className={styled.item} onClick={()=> setCurOpinion(sogyunseo)}>
                <div className={styled.check} onClick={(e)=>{e.stopPropagation()}}>
                    <input type="checkbox" checked={isChecked}
                    onChange={(e)=>{e.stopPropagation(); setCheck(sogyunseo.id, !isChecked)}}/> 
                </div>
                <div className={styled.title}>{sogyunseo?.diagnosis ?? "진단명"}</div>
                <div className={styled.recipient}>{sogyunseo?.writer ?? "작성자"}</div>
                <div className={styled.guardian_name}>{sogyunseo?.guardianName ?? "보호자이름"}</div>
                <div className={styled.patient_name}>{sogyunseo?.petName ?? "환자이름"}</div>
                <div className={styled.sent_time}>{formatDateToDateTimeString(sogyunseo?.createdAt)}</div>
            </div>
        )
    }
    interface menuProp {
        tit:string,
        exec: (e: React.MouseEvent<HTMLDivElement>) => void
    }

    const SogyunseoHeader = ({checkList}:any) => {
        const [leftMenu, setLeftMenu] = useState<menuProp[]>([])
        const [rightMenu, setRightMenu] = useState<menuProp[]>([])
        const checkListRef = useRef<any[]>(checkList)

        useEffect(()=>{ checkListRef.current = checkList },[checkList])

        const setTarget = useCallback(()=> {
            if(curOpinion) return curOpinion.id
            else return checkListRef.current
        }, [checkList, curOpinion])
        
        const deleteOpinions = async()=> {
            const target = setTarget()
            if(Array.isArray(target) && target.length == 0) return alert("선택된 소견서가 없습니다")
            
            const data = await axios.put(`${BASEURL}/opinion/delete`,{opinionID : target}, {
                headers: {Authorization: `Bearer ${accessToken}`,}
            }).then(res=>res.data).then(data => {
                if (data.status === "success") {
                    alert("소견서 삭제를 완료했습니다.")
                } else { return null }
            }).catch(error => {
                if(error.response) {
                    if(error.response?.data?.message === "some opinions have invalid state")
                    alert("선택된 소견서 중 삭제할 수 없는 소견서가 있습니다.")
                } else {                    
                    alert(`소견서 삭제를 실패했습니다.`)
                }
                return null
            }).finally(()=>{
                loadOpinionList()
                if(curOpinion) setCurOpinion(null)
            })
        }
        const deleteOpinionPermanent = async()=> {
            const target = setTarget()
            if(Array.isArray(target) && target.length == 0) return alert("선택된 소견서가 없습니다")
            const data = await axios.put(`${BASEURL}/opinion/purge`,{opinionID : target}, {
                headers: {Authorization: `Bearer ${accessToken}`,}
            }).then(res=>res.data).then(data => {
                if (data.status === "success") {
                    alert("소견서를 완전 삭제했습니다.")
                } else { return null }
            }).catch(error => {
                if(error.response) {
                    if(error.response?.data?.message === "some opinions have invalid state")
                    alert("선택된 소견서 중 삭제할 수 없는 소견서가 있습니다.")
                } else {                    
                    alert(`소견서 삭제를 실패했습니다.`)
                }
                return null
            }).finally(()=>{
                loadOpinionList()
                if(curOpinion) setCurOpinion(null)
            })
        }

        const restoreOpinions = async()=> {
            const target = setTarget()
            if(Array.isArray(target) && target.length == 0) return alert("선택된 소견서가 없습니다")
           
            const data = await axios.put(`${BASEURL}/opinion/restore`,{opinionID : target}, {
                headers: {Authorization: `Bearer ${accessToken}`,}
            }).then(res=>res.data).then(data => {
                if (data.status === "success") {
                    alert("소견서 복원을 완료했습니다.")
                    loadOpinionList()
                } else { return null }
            }).catch(error => {
                if(error.response) {
                    if(error.response?.data?.message === "some opinions have invalid state")
                    alert("선택된 소견서 중 복원할 수 없는 소견서가 있습니다.")
                } else {                    
                    alert(`소견서 복원을 실패했습니다.`)
                }
                return null
            }).finally(()=>{loadOpinionList()})
        }
     

        useEffect(()=>{
            if(menu == 3) { // 휴지통
                if(curOpinion != null) {
                    setLeftMenu(
                        [{tit: "복원", exec: restoreOpinions}]
                    )
                    setRightMenu(
                        [{tit: "목록", exec: ()=> {}},
                        {tit: "영구삭제", exec: deleteOpinionPermanent}]
                    )
                }
                else {
                    setLeftMenu(
                        [{tit: "복원", exec: restoreOpinions}]
                    )
                    setRightMenu(
                        [{tit: "영구삭제", exec: deleteOpinionPermanent}]
                    )
                }
            } else { // 휴지통 외
                if(curOpinion != null) {
                    setLeftMenu(
                        [{tit: "전송", exec: ()=> {}},
                         {tit: "다운로드", exec: ()=> {}},
                        ]
                    )
                    setRightMenu(
                        [{tit: "목록", exec: ()=> {}},
                         {tit: "삭제", exec: deleteOpinions}]
                    )
                }
                else {
                    setLeftMenu(
                        [{tit: "전송", exec: ()=> {}},
                         {tit: "다운로드", exec: ()=> {}},
                        ]
                    )
                    setRightMenu(
                        [{tit: "삭제", exec: deleteOpinions}]
                    )
                }
            }
        },[menu, curOpinion])

        return (
            <div className={styled.header}>
                <div className={styled.menu}>
                    {leftMenu.map((lm)=>{ return (<div onClick={lm.exec}>{lm.tit}</div>)})}
                </div>
                <div className={styled.menu}>
                    {rightMenu.map((rm)=> { return (<div onClick={rm.exec}>{rm.tit}</div>)})}
                </div>
            </div>
        )
    }
    const DocumentList = () => {
        const [checkList, setCheckList] = useState<number[]>([])

        // temp data
        const [docList, setDocList] = useState<any[]>([])
        const [docs, setDocs] = useState<any[]>([])
        const PAGE_SIZE = 5
        const [curPage, setCurPage] = useState(1)

        useEffect(() => {
            let filteredList:any[] = []
            switch (menu) {
                case 0:
                     // TODO : 전체 문서, 보험진단서를 가져오면 전체문서에 표시
                    filteredList = opinionList
                    break
                case 1:
                    filteredList = opinionList.filter(item => item.state !== "deleted")
                    break
                case 2:
                    // TODO: 보험진단서 데이터를 설정
                    filteredList = [] 
                    break
                case 3:
                    filteredList = opinionList.filter(item => item.state === "deleted")
                    break
                default:
                    filteredList = []
            }
            setDocList(filteredList)
            setCurPage(1)
        }, [opinionList, menu])

        const handleSelectPage = (num:any) => {setCurPage(num)}
        const handlePrevPage = () => {  if (curPage > 1) {  setCurPage(curPage - 1)} }
        const handleNextPage = () => {
            const totalPages = Math.ceil(docList.length / PAGE_SIZE)
            if (curPage < totalPages) { setCurPage(curPage + 1) }
        }

        // page가 바뀔 때마다 체크리스트를 초기화
        useEffect(()=>{ setCheckList([])},[curPage])

        // pagenation
        useEffect(()=>{
            setDocs(docList.slice((curPage - 1) * PAGE_SIZE, curPage * PAGE_SIZE))
        },[curPage, docList])
    
        return (
            <>
                <SogyunseoHeader checkList={checkList}/>
                <div className={styled.contents}>
                    {curOpinion ? <SogyunseoDetails/> 
                        : <SogyunseoList sogyunseoList={docs}
                            checkList={checkList}
                            setCheckList={setCheckList}/>}
                </div>
                { !curOpinion && 
                <div className={styled.pagination}>
                    <button onClick={handlePrevPage}>&lt;</button>
                        {docList.length > 0 && 
                Array.from({ length: Math.ceil(docList.length / PAGE_SIZE) }).map((_, index) => (
                    <button key={index} onClick={()=>handleSelectPage(index+1)}>{index + 1}</button>
                ))}
                    <button onClick={handleNextPage}>&gt;</button>
                </div>}    
            </>
       )
    }

    return (
        <div className={styled.container} style={{height:'100%'}}>
            <div className={styled.hos_opi}>
                <div className={styled.top}>
                    <span className={styled.tit}>문서관리</span>
                </div> 
                <div className={styled.box}>
                    <div className={styled.left}>
                        <div className={`${styled.menu} ${(menu == 0 && styled.select)}`}
                            onClick={()=>handleMenu(0)}>전체 문서</div>
                        <div className={`${styled.menu} ${(menu == 1 && styled.select)}`} 
                        onClick={()=>handleMenu(1)}>소견서</div>
                        <div className={`${styled.menu} ${(menu == 2 && styled.select)}`}
                        onClick={()=>handleMenu(2)}>보험 진단서</div>
                        <div className={`${styled.menu} ${(menu == 3 && styled.select)}`}
                        onClick={()=>handleMenu(3)}>휴지통</div>
                    </div>
                    <div className={styled.right}>
                        <DocumentList/>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default HospitalOpinion
